module.exports = __webpack_public_path__ + "img/user.00bc5fcb.svg";